import React, { createContext, useContext, useState } from 'react';
import { ProfileMenu } from '@/components/ProfileMenu';
import { ProfileMenuView } from '@/types/components';

interface ProfileMenuContextValue {
  open: (view?: ProfileMenuView) => void;
  close: () => void;
}

const ProfileMenuContext = createContext<ProfileMenuContextValue | null>(null);

export const useProfileMenu = (): ProfileMenuContextValue => {
  const context = useContext(ProfileMenuContext);

  if (!context) {
    throw new Error('useProfileMenu must be used within ProfileMenuProvider');
  }

  return context;
};

interface Props {
  children: React.ReactNode;
}

export const ProfileMenuProvider: React.FC<Props> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialView, setInitialView] = useState(ProfileMenuView.Menu);

  const open = (view: ProfileMenuView = ProfileMenuView.Menu) => {
    setInitialView(view);
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  return (
    <ProfileMenuContext.Provider value={{ open, close }}>
      {children}
      <ProfileMenu isOpen={isOpen} initialView={initialView} onClose={close} />
    </ProfileMenuContext.Provider>
  );
};
